export function formatCEP(value: string) {
  const digits = value.replace(/\D/g, '');
  return digits.replace(/^(\d{5})(\d)/, '$1-$2').slice(0, 9);
}
